import { Button, Card, Checkbox, Col, Form, Input, Row, Select } from "antd";
import { collection, doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../../../firebase";

const AboutProperty = ({ data, dataId, isUpdate,companyName }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);

  const initialValues = {
    propertyType: data?.propertyType,
    propertyName: data?.propertyName,
    propertyAddressOne: data?.addressLine1,
    propertyAddressTwo: data?.addressLine2,
    city: data?.city,
    state: data?.state,
    zipCode: data?.zipCode,
    country: data?.country,
    affordableHousingProperty: data?.affordableHousingProperty,
  };

  const onFinish = (values) => {
    console.log("Success:", values);

    isUpdate(true);
    setIsWaiting(true);

    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);
      updateDoc(propertyDocRef, {
        "propertyNameAddress.propertyName": values.propertyName || "",
        "propertyNameAddress.propertyType": values.propertyType || "",
        "propertyNameAddress.city": values.city || "",
        "propertyNameAddress.state": values.state || "",
        "propertyNameAddress.zipCode": values.zipCode || "",
        "propertyNameAddress.country": values.country || "",
        "propertyNameAddress.addressLine1": values.propertyAddressOne || "",
        "propertyNameAddress.addressLine2": values.propertyAddressTwo || "",
        "propertyNameAddress.affordableHousingProperty":
          values.affordableHousingProperty || "",
      });

      setTimeout(() => {
        setIsEditActive(false);
        setIsWaiting(false);
      }, 3000);
    } catch (error) {
      console.error("not updated:", error);
      setIsWaiting(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWaiting(false);
  };

  return (
    <div>
      <Card
        size="small"
        title={!isEditActive ? data?.propertyName : ""}
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
                setIsWaiting(false);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          autoComplete="off"
          colon={false}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Property Type"
            name="propertyType"
            required={isEditActive ? true : false}
          >
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "Single-Family",
                  },
                ]}
              />
            ) : (
              <p>{data?.propertyType}</p>
            )}
          </Form.Item>
          {isEditActive && (
            <Form.Item label="Property Name" name="propertyName">
              <Input />
            </Form.Item>
          )}
          <Form.Item label="Address" name="propertyAddressOne">
            {isEditActive ? (
              <Input placeholder="Address 1" />
            ) : (
              <a href="">
                {data?.propertyName} <br />
                {data?.city} {data?.state} {data?.zipCode}
              </a>
            )}
          </Form.Item>
          {isEditActive && (
            <Form.Item label=" " name="propertyAddressTwo">
              <Input placeholder="Address 2" />
            </Form.Item>
          )}
          {isEditActive && (
            <Form.Item label=" ">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="" name="city">
                    <Input placeholder="City" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label=" " name="state">
                    <Select
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        {
                          value: "OK",
                        },
                        {
                          value: "OR",
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label=" " name="zipCode">
                    <Input placeholder="Zip" />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>
          )}

          <Form.Item label="Country" name="country">
            {isEditActive ? (
              <Input placeholder="country" />
            ) : (
              <p>{data?.country}</p>
            )}
          </Form.Item>
          <Form.Item
            label="Affordable Housing Property"
            name="affordableHousingProperty"
            valuePropName="checked"
          >
            {isEditActive ? (
              <Checkbox></Checkbox>
            ) : (
              <p>{data?.affordableHousingProperty ? "Yes" : "No"}</p>
            )}
          </Form.Item>
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default AboutProperty;
